export const formatToTimestamp = seconds => {
  if (seconds <= 0) return "00:00:00"

  let timestamp = new Date(seconds * 1000).toISOString().slice(11, 19)

  return timestamp
}
